import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject } from 'rxjs';
import { AppConstant } from 'src/app/app.constant';

@Injectable()
export class StudentAssessmentService extends BehaviorSubject<GridDataResult> {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        super(null);
        this.apiUrl = this.appConstant.getUrl();
        this.kendoDataUrl = this.apiUrl + 'GetAll';
    }
    getAllStudentAssessment(assessmentData): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllStudentAssessment/`, assessmentData).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getAllStudentAssessmentExcel(assessmentData) {
        return new Promise((resolve, reject) => {
          this.httpClient.post(`${this.apiUrl}/getAllStudentAssessment`,assessmentData).pipe(
            map(res => res))
            .subscribe(res => {
              resolve(res);
            }, (err) => {
              reject(err);
            });
        });
      }
}
